import {
  Box,
  Container,
  Stack,
  Typography,
  useMediaQuery,
  Avatar,
  Chip,
} from "@mui/material";
import InfiniteScrollTable from "app/components/Tables/InfiniteScrollTable";
import ExportButtonGroup from "app/components/common/ExportButtonGroup";
import React, { useMemo, useState, useRef } from "react";
import { getEkalsutraStaff } from "app/services/org/crm/crm.service";
import TableActionButtons from "app/components/common/TableActionButtons";
import { Helmet } from "react-helmet";
import dayjs from "dayjs";

const EkalsutraStaffPage = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  // Memoize default API params to prevent re-creation on every render
  const defaultApiParams = useMemo(() => ({}), []);

  const [state, setState] = useState({
    tableData: [],
    viewDialog: false,
    selectedStaff: null,
  });

  const [enabled, setEnabled] = useState(1);
  const enabledRef = useRef(1);

  // Table columns configuration
  const columns = useMemo(() => {
    return [
      {
        header: "Sr.No",
        Cell: ({ cell }) => (
          <Typography>{parseInt(cell.row.id) + 1}</Typography>
        ),
        maxSize: 20,
      },
      {
        header: "Employee ID",
        accessorKey: "employeeId",
        maxSize: 40,
      },
      {
        header: "Name",
        accessorKey: "firstName",
        Cell: ({ cell, row }) => (
          <Typography>
            {row.original?.firstName}{" "}
            {row.original?.middleName ? row.original?.middleName + " " : ""}
            {row.original?.lastName}
          </Typography>
        ),
        maxSize: 50,
      },
      {
        header: "Mobile No.",
        accessorKey: "mobileNumber",
        maxSize: 40,
      },
      {
        header: "Department",
        accessorKey: "departmentName",
        Cell: ({ cell }) => <Typography>{cell.getValue() || "N/A"}</Typography>,
        maxSize: 40,
      },
      {
        header: "Primary Role",
        accessorKey: "primaryRole",
        Cell: ({ cell }) => (
          <Chip
            label={cell.getValue() || "N/A"}
            size="small"
            sx={{
              fontWeight: 500,
              fontSize: "12px",
              bgcolor: "#E3F2FD",
              color: "#1976D2",
            }}
          />
        ),
        maxSize: 40,
      },
      {
        header: "Employment Type",
        accessorKey: "employmentType",
        Cell: ({ cell }) => (
          <Typography sx={{ textTransform: "capitalize" }}>
            {cell.getValue()?.replace("_", " ") || "N/A"}
          </Typography>
        ),
        maxSize: 40,
      },
      {
        header: "Gender",
        accessorKey: "gender",
        Cell: ({ cell }) => (
          <Typography sx={{ textTransform: "capitalize" }}>
            {cell.getValue() || "N/A"}
          </Typography>
        ),
        maxSize: 30,
      },
      {
        header: "DOB",
        accessorKey: "DOB",
        Cell: ({ cell, row }) => (
          <Typography>
            {row.original?.DOB
              ? dayjs(row.original?.DOB).format("DD MMM, YYYY")
              : "N/A"}
          </Typography>
        ),
        maxSize: 40,
      },
      {
        header: "Joining Date",
        accessorKey: "joiningDate",
        Cell: ({ cell, row }) => (
          <Typography>
            {row.original?.joiningDate
              ? dayjs(row.original?.joiningDate).format("DD MMM, YYYY")
              : "N/A"}
          </Typography>
        ),
        maxSize: 40,
      },
      {
        header: "Actions",
        Cell: ({
          cell: {
            row: { original },
          },
        }) => {
          return (
            <TableActionButtons
              showView
              showEdit
              handleView={() =>
                setState((prev) => ({
                  ...prev,
                  viewDialog: true,
                  selectedStaff: original,
                }))
              }
              handleEdit={() => {
                // Handle edit functionality
                console.log("Edit staff:", original);
              }}
            />
          );
        },
        maxSize: 30,
      },
    ];
  }, []);

  return (
    <>
      <Helmet>
        <title>Ekalsutra Staff | Staff Management</title>
      </Helmet>

      <Container maxWidth="xl" disableGutters={isMobile ? true : false}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ mb: 2 }}
        >
          <Box>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 600,
                color: "#0C2F49",
                mb: 0.5,
              }}
            >
              Ekalsutra Staff
            </Typography>
          </Box>
          <Box sx={{ display: { xs: "none", md: "block" } }}>
            <ExportButtonGroup
              showExcel
              showPdf={false}
              handleClickExcel={() => {
                // Handle export functionality
                console.log("Export staff list");
              }}
            />
          </Box>
        </Stack>

        <Box sx={{ mt: 2 }}>
          <InfiniteScrollTable
            columns={columns}
            maxHeight="65vh"
            apiUrl={getEkalsutraStaff}
            apiParams={state.filterData || defaultApiParams}
            setState={setState}
            enabled={enabled}
            setEnabled={setEnabled}
            filterRefresh={false}
          />
        </Box>
      </Container>
    </>
  );
};

export default EkalsutraStaffPage;
